import generic_backend_request_post from 'functions/server/generic_backend_request_post';

async function list_examples() {
    /**
     * Fetches the list of published example scenarios from the backend.
     *
     * Sends a POST to /list_examples (no request body). Each row describes one
     * example card and includes the fields needed to render it and to load it:
     *   instance_id, slug, scenario_name, title, brief_description,
     *   banner_image, model_type, constraints[], tags[], summary[]
     *
     * `summary` is a real array of single-key stat objects
     * (e.g. [{ "Locations": 17 }, { "Trips": 12 }]) — no JSON.parse needed.
     *
     * @return {Array<Object>} The list of example scenario cards (may be empty).
     */
    const retJson = await generic_backend_request_post({}, '/list_examples');
    return retJson;
}

export default list_examples;
